import React from 'react'

import moment from "moment"
import logo from '../../../assets/images/logo.png';
// import manchesterlogo from '../../../assets/images/manchesterlogo.png';
// import reallogo from '../../../assets/images/reallogo.png';

import './index.css';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Template from "../Template";

const FreePoint = () => {
    const { user } = useSelector((state) => state.auth);
    const { playList, team1Idx, eventDate } = useSelector((state) => state.sport);

    return (
        <>
            <Template>
                <div className='screen-4-section'>
                    <div className='screen-4-content' style={{ height: '100%' }}>
                        <div className='screen-top-part'>
                            <div className='logo-part'>
                                <Link to='/'>
                                    <img src={logo} alt="logo" className='img-fluid' />
                                </Link>
                            </div>
                            <span className='screen-title'>Your Game</span>
                            <div className='select-team-group'>
                                <div className='select-team'>
                                    <div className='team-image'>
                                        {playList.boxscore ? <img src={playList.boxscore.teams[0].team.logo} alt={playList.boxscore && playList.boxscore.teams[0].team.shortDisplayName} style={{ width: 43, height: 43 }} /> : <div></div>}
                                    </div>
                                    <span>{playList.boxscore && playList.boxscore.teams[0].team.shortDisplayName}</span>
                                </div>
                                <div className='opposite-part'>vs <span>{eventDate && moment(eventDate).format("h:mm")}</span></div>
                                <div className='select-team'>
                                    <div className='team-image'>
                                        {playList.boxscore ? <img src={playList.boxscore.teams[1].team.logo} alt={playList.boxscore && playList.boxscore.teams[1].team.shortDisplayName} style={{ width: 43, height: 43 }} /> : <div></div>}
                                    </div>
                                    <span>{playList.boxscore && playList.boxscore.teams[1].team.shortDisplayName}</span>
                                </div>
                            </div>
                            <div className='your-team-block'>
                                <div className='your-team'>
                                    <h4>Your Team</h4>
                                </div>
                                <div className='select-team'>
                                    <div className='team-image'>
                                        {playList.boxscore ? <img src={playList.boxscore.teams[team1Idx].team.logo} alt={playList.boxscore && playList.boxscore.teams[team1Idx].team.shortDisplayName} style={{ width: 27, height: 27 }} /> : <div></div>}
                                    </div>
                                    <span>{playList.boxscore && playList.boxscore.teams[team1Idx].team.shortDisplayName}</span>
                                </div>
                            </div>
                        </div>
                        <div className='play-free-game-block'>
                            <span className='screen-purple-glow-title'>Have <span>Fun!</span></span>
                            {/* <Link to="/play" className='chance-to-win-block'>
                                <span className='free-info'>Free</span>
                                <div className='chance-to-win-info'>
                                    <p>Play for a chance
                                        <span>to Win $25</span></p>
                                </div>
                            </Link> */}
                            <div className='no-thanks-btn-block'>
                                <Link to="/play">Enter Game</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    )
}

export default FreePoint
